import { Template } from "core/types/index";
import i18next from "i18next";

// In the database these templates have the misspelled names
// "live_management_30" and "live_management_60".
const TEMPLATE_TRANSLATION_KEY_MAP: Record<string, string> = {
  LIVE_MANAGEMENT_30: "LINE_MANAGEMENT_30",
  LIVE_MANAGEMENT_60: "LINE_MANAGEMENT_15",
};

export function getTemplateTranslationKey(name: string): string {
  const upper = name.toUpperCase();
  return TEMPLATE_TRANSLATION_KEY_MAP[upper] ?? upper;
}

export function getTemplateName(name: string, t: typeof i18next.t) {
  return t(getTemplateTranslationKey(name), "*Unknown*");
}

export function getNameFromTemplates(
  templates: Template[],
  templateId: number,
) {
  if (!templates) return null;
  return (
    templates.find((template) => template.templateId === templateId) ?? null
  );
}

export const getTemplate = (type: number | string, templates: Template[]) => {
  if (templates && templates.length > 0) {
    return (
      templates.find((template) => {
        return template.templateId === type || template.name === type;
      }) ?? null
    );
  }
  return null;
};
